import { PlatformCode } from 'type/common';
import { IMatchDB } from 'utils/dummy';
import { floatFixed, roundFloat } from 'utils/round';

interface IDataItem {
	name: string;
	code: string;
}

// 카테고리
export const ig_category: string[] = [
	'만화/애니/툰',
	'유머/짤',
	'스타/연예인',
	'문학/책',
	'영화',
	'미술/디자인',
	'공연/전시',
	'음악',
	'고양이',
	'강아지',
	'기타반려동물',
	'육아/키즈',
	'결혼/연애',
	'홈/리빙',
	'패션',
	'뷰티',
	'요리/레시피',
	'문구/완구',
	'라이브커머스/쇼호스트',
	'건강가전',
	'다이어트/건강보조식품',
	'헬스',
	'홈트/요가/필라테스',
	'취미/놀이',
	'게임',
	'사진/영상',
	'스포츠',
	'국내여행',
	'세계여행',
	'맛집',
	'유명장소/핫플',
	'시사/이슈',
	'일상',
	'교육',
	'모빌리티/자동차',
	'디지털기기',
];

export const yt_category: string[] = [
	'스타/연예인',
	'만화/애니',
	'웹컨텐츠/웹드라마',
	'TV/방송',
	'스트리머/BJ',
	'먹방',
	'문학/예술',
	'미술/디자인',
	'공연/전시',
	'음악',
	'댄스',
	'고양이',
	'강아지',
	'야생동물',
	'기타반려동물',
	'육아/키즈',
	'결혼/연애',
	'홈/리빙',
	'패션',
	'뷰티',
	'요리/레시피',
	'문구/완구',
	'의학정보',
	'의약품/건강보조식품',
	'다이어트',
	'헬스',
	'홈트/요가/필라테스',
	'취미/놀이',
	'게임',
	'사진/영상',
	'스포츠',
	'아웃도어',
	'국내여행',
	'해외여행',
	'맛집',
	'유명장소/핫플',
	'시사/이슈/정보',
	'주식/재테크',
	'브이로그',
	'동기부여/자기계발',
	'어학/외국어',
	'강연/강의',
	'취업/커리어',
	'유아교육',
	'모빌리티',
	'IT/테크',
	'디지털기기',
];

export const nb_category: string[] = [
	'스타/연예인',
	'만화/애니',
	'방송',
	'드라마',
	'문학/책',
	'영화',
	'미술/디자인',
	'공연/전시',
	'음악',
	'육아/결혼',
	'패션/미용',
	'인테리어/DIY',
	'요리/레시피',
	'상품리뷰',
	'원예/재배',
	'건강/의학',
	'애완/반려동물',
	'취미',
	'게임',
	'스포츠',
	'사진',
	'국내여행',
	'세계여행',
	'맛집',
	'사회/정치',
	'비즈니스/경제',
	'일상/생각',
	'좋은글/이미지',
	'어학/외국어',
	'교육/학문',
	'IT/컴퓨터',
	'자동차',
];

export const tt_category: string[] = [
	'먹방',
	'댄스/음악',
	'방송/미디어',
	'예술/공예',
	'애완동물',
	'결혼/연애',
	'뷰티',
	'식품/요리',
	'유아/키즈',
	'패션',
	'홈리빙/가전제품',
	'건강/웰니스',
	'헬스/홈트/요가/필라테스',
	'게임',
	'사진/영상',
	'스포츠/아웃도어',
	'취미/놀이',
	'맛집',
	'여행/관광',
	'금융/재테크',
	'시사/이슈/정보',
	'일상/코미디',
	'교육/훈련',
	'IT/테크',
	'디지털기기',
	'자동차/교통수단',
];

// 팔로워 (구독자 || 누적방문자)
export const ig_follower: IDataItem[] = [
	{ name: '0 ~ 500명 미만', code: 'ig_0' },
	{ name: '500 ~ 1,000명 미만', code: 'ig_1' },
	{ name: '1,000 ~ 2,000명 미만', code: 'ig_2' },
	{ name: '2,000 ~ 5,000명 미만', code: 'ig_3' },
	{ name: '5,000 ~ 1만 명 미만', code: 'ig_4' },
	{ name: '1만 ~ 3만 명 미만', code: 'ig_5' },
	{ name: '3만 ~ 5만 명 미만', code: 'ig_6' },
	{ name: '5만 ~ 10만 명 미만', code: 'ig_7' },
	{ name: '10만 ~ 20만 명 미만', code: 'ig_8' },
	{ name: '20만 ~  50만 명 미만', code: 'ig_9' },
	{ name: '50만 ~  100만 명 미만', code: 'ig_10' },
	{ name: '100만 ~  300만 명 미만', code: 'ig_11' },
	{ name: '300만 ~  500만 명 미만', code: 'ig_12' },
	{ name: '500만 명 이상', code: 'ig_13' },
];
export const yt_follower: IDataItem[] = [
	{ name: '0 ~ 500명 미만', code: 'yt_0' },
	{ name: '500 ~ 1,000명 미만', code: 'yt_1' },
	{ name: '1,000 ~ 2,000명 미만', code: 'yt_2' },
	{ name: '2,000 ~ 5,000명 미만', code: 'yt_3' },
	{ name: '5,000 ~ 1만 명 미만', code: 'yt_4' },
	{ name: '1만 ~ 3만 명 미만', code: 'yt_5' },
	{ name: '3만 ~ 5만 명 미만', code: 'yt_6' },
	{ name: '5만 ~ 10만 명 미만', code: 'yt_7' },
	{ name: '10만 ~ 20만 명 미만', code: 'yt_8' },
	{ name: '20만 ~  50만 명 미만', code: 'yt_9' },
	{ name: '50만 ~  100만 명 미만', code: 'yt_10' },
	{ name: '100만 ~  300만 명 미만', code: 'yt_11' },
	{ name: '300만 ~  500만 명 미만', code: 'yt_12' },
	{ name: '500만 명 이상', code: 'yt_13' },
];
export const nb_follower: IDataItem[] = [
	{ name: '0 ~ 15만 명 미만', code: 'nb_0' },
	{ name: '15만 ~ 30만 명 미만', code: 'nb_1' },
	{ name: '30만 ~ 60만 명 미만', code: 'nb_2' },
	{ name: '60만 ~ 150만 명 미만', code: 'nb_3' },
	{ name: '150만 ~ 300만 명 미만', code: 'nb_4' },
	{ name: '300만 ~ 600만 명 미만', code: 'nb_5' },
	{ name: '600만 ~ 1,000만 명 미만', code: 'nb_6' },
	{ name: '1,000만 ~ 2,000만 명 미만', code: 'nb_7' },
	{ name: '2,000만 ~ 2,500만 명 미만', code: 'nb_8' },
	{ name: '2,500만 ~ 3,000만 명 미만', code: 'nb_9' },
	{ name: '3,000만 ~ 4,500만 명 미만', code: 'nb_10' },
	{ name: '4,500만 ~ 7,000만 명 미만', code: 'nb_11' },
	{ name: '7,000만 ~ 9,500만 명 미만', code: 'nb_12' },
	{ name: '9,500만 명 이상', code: 'nb_13' },
];
export const tt_follower: IDataItem[] = [
	{ name: '0 ~ 500명 미만', code: 'tt_0' },
	{ name: '500 ~ 1,000명 미만', code: 'tt_1' },
	{ name: '1,000 ~ 2,000명 미만', code: 'tt_2' },
	{ name: '2,000 ~ 5,000명 미만', code: 'tt_3' },
	{ name: '5,000 ~ 1만 명 미만', code: 'tt_4' },
	{ name: '1만 ~ 3만 명 미만', code: 'tt_5' },
	{ name: '3만 ~ 5만 명 미만', code: 'tt_6' },
	{ name: '5만 ~ 10만 명 미만', code: 'tt_7' },
	{ name: '10만 ~ 20만 명 미만', code: 'tt_8' },
	{ name: '20만 ~  50만 명 미만', code: 'tt_9' },
	{ name: '50만 ~  100만 명 미만', code: 'tt_10' },
	{ name: '100만 ~  300만 명 미만', code: 'tt_11' },
	{ name: '300만 ~  500만 명 미만', code: 'tt_12' },
	{ name: '500만 명 이상', code: 'tt_13' },
];

// 연령대
export const ig_age: IDataItem[] = [
	{ name: '18-24세', code: '18' },
	{ name: '25-34세', code: '25' },
	{ name: '35-44세', code: '35' },
	{ name: '45-54세', code: '45' },
	{ name: '55세+', code: '55' },
];
export const yt_age: IDataItem[] = [
	{ name: '13-17세', code: '13' },
	{ name: '18-24세', code: '18' },
	{ name: '25-34세', code: '25' },
	{ name: '35-44세', code: '35' },
	{ name: '45-54세', code: '45' },
	{ name: '55세+', code: '55' },
];
export const tt_age: IDataItem[] = [
	{ name: '18-24세', code: '18' },
	{ name: '25-34세', code: '25' },
	{ name: '35-44세', code: '35' },
	{ name: '45-54세', code: '45' },
	{ name: '55세+', code: '55' },
];

// 컨텐츠 유형
export const ig_content_type: IDataItem[] = [
	{ name: '릴스', code: 'sub_video' },
	{ name: '일반', code: 'normal' },
];
export const yt_content_type: IDataItem[] = [
	{ name: '쇼츠', code: 'sub_video' },
	{ name: '일반', code: 'normal' },
];

// 계정 유형
export const account_type: IDataItem[] = [
	{ name: '셀럽', code: 'brand' },
	{ name: '일반', code: 'normal' },
];

// 성별
export const gender: IDataItem[] = [
	{ name: '여성', code: 'F' },
	{ name: '남성', code: 'M' },
];

export const campaign_experience: IDataItem[] = [
	{ name: '체험단/협찬', code: 'sponsored_experience' },
	{ name: '공동 구매', code: 'group_purchase_experience' },
];

/** 카테고리 리스트를 IDataItem 타입으로 변환 */
const categoryToDataItemType = (list: string[]): IDataItem[] =>
	list.map((item) => ({ name: item, code: item }));

/** 리스트에 전체 항목을 포함 */
const allAddedList = (list: IDataItem[]) => {
	return [{ name: '전체', code: 'all' }, ...list];
};

/** ig 필터 셀렉트 박스 데이터 */
export const ig_filter_data = [
	{
		label: '콘텐츠 유형',
		list: allAddedList(ig_content_type),
		label_code: 'content_type',
	},
	{ label: '계정 유형', list: allAddedList(account_type), label_code: 'account_type' },
	{
		label: '카테고리',
		list: allAddedList(categoryToDataItemType([])),
		label_code: 'categories',
	},
	{ label: '팔로워 수', list: allAddedList(ig_follower), label_code: 'followers' },
	{ label: '오디언스 성별', list: allAddedList(gender), label_code: 'estimate_gender' },
	{ label: '오디언스 연령대', list: allAddedList(ig_age), label_code: 'estimate_age' },
	{
		label: '캠페인 경험',
		list: allAddedList(campaign_experience),
		label_code: 'campaign_experience',
	},
];
/** yt 필터 셀렉트 박스 데이터 */
export const yt_filter_data = [
	{
		label: '콘텐츠 유형',
		list: allAddedList(yt_content_type),
		label_code: 'content_type',
	},
	{
		label: '카테고리',
		list: allAddedList(categoryToDataItemType([])),
		label_code: 'categories',
	},
	{ label: '구독자 수', list: allAddedList(yt_follower), label_code: 'followers' },
	{ label: '오디언스 성별', list: allAddedList(gender), label_code: 'estimate_gender' },
	{ label: '오디언스 연령대', list: allAddedList(yt_age), label_code: 'estimate_age' },
];
/** nb 필터 셀렉트 박스 데이터 */
export const nb_filter_data = [
	{
		label: '카테고리',
		list: allAddedList(categoryToDataItemType([])),
		label_code: 'categories',
	},
	{ label: '누적 방문자 수', list: allAddedList(nb_follower), label_code: 'followers' },
];

/** tt 필터 셀렉트 박스 데이터 */
export const tt_filter_data = [
	{
		label: '카테고리',
		list: allAddedList(categoryToDataItemType([])),
		label_code: 'categories',
	},
	{
		label: '팔로워 수',
		list: allAddedList(tt_follower),
		label_code: 'followers',
	},
	{
		label: '오디언스 성별',
		list: allAddedList(gender),
		label_code: 'estimate_gender',
	},
	{
		label: '오디언스 연령대',
		list: allAddedList(tt_age),
		label_code: 'estimate_age',
	},
];

export const category_mapper = {
	ig: ig_category,
	yt: yt_category,
	nb: nb_category,
	tt: tt_category,
};

export const filter_data_mapper = {
	ig: ig_filter_data,
	yt: yt_filter_data,
	nb: nb_filter_data,
	tt: tt_filter_data,
};

export const setAgeSection = (age: number | null): string => {
	if (age === null) return '';

	const round_age = Math.round(age);

	const result = yt_age.find((item, idx) => {
		if (round_age >= +yt_age[yt_age.length - 1].code) return idx === yt_age.length - 1;
		if (round_age < +yt_age[0].code) return idx === 0;
		else {
			return round_age >= +item.code && round_age < +yt_age[idx + 1].code;
		}
	});

	return result?.name ?? '';
};

export const gender_mapper = {
	F: '여성',
	M: '남성',
};

export const setFollowerRange = (follower_count: number | null): string => {
	if (follower_count == null) return '';
	const result = ig_follower.find((item, idx) => {
		if (follower_count >= 5000000) return idx === 13;
		else if (follower_count >= 0 && follower_count < 5000) {
			const start: number = +item.name.split(' ~ ')[0].replace(',', '');
			const end = +item.name.split(' ~ ')[1].split('명')[0].replace(',', '');
			return follower_count >= start && follower_count < end;
		} else if (follower_count >= 5000 && follower_count < 10000) return idx === 4;
		else if (follower_count >= 10000 && follower_count < 5000000) {
			const start: number = +(item.name.split(' ~ ')[0].replace('만', '') + '0000');
			const end: number = +(item.name.split(' ~ ')[1].split('만')[0] + '0000');
			return follower_count >= start && follower_count < end;
		}
	});
	return result?.name ?? '';
};

export const setTotalVisitorRange = (total_visitor_count: number | null): string => {
	if (total_visitor_count == null) return '';
	const result = nb_follower.find((item, idx) => {
		if (total_visitor_count >= 95000000) return idx === 13;
		else if (total_visitor_count >= 0 && total_visitor_count < 150000) return idx === 0;
		else if (total_visitor_count >= 150000 && total_visitor_count < 95000000) {
			const start: number = +(
				item.name.split(' ~ ')[0].replace('만', '').replace(',', '') + '0000'
			);

			const end = +(item.name.split(' ~ ')[1].replace(',', '').split('만')[0] + '0000');
			return total_visitor_count >= start && total_visitor_count < end;
		}
	});
	return result?.name ?? '';
};

export const setFollowerGrowthRate = (match_item: IMatchDB) => {
	const setIndex = () => {
		if (+match_item?.follower_growth_rate > 0) return 0;
		if (+match_item?.follower_growth_rate === 0) return 2;
		if (+match_item?.follower_growth_rate < 0) return 1;
		else return '2';
	};

	const arrow_arr = ['▲ ', '▼ ', ''];

	const follower_growth_rate =
		match_item?.follower_growth_rate !== null &&
		match_item?.follower_growth_rate !== undefined
			? floatFixed(roundFloat(match_item?.follower_growth_rate, 'down', 2), 2) + '%'
			: '-';
	const follower_growth =
		match_item?.follower_growth !== null && match_item?.follower_growth !== undefined
			? floatFixed(roundFloat(match_item?.follower_growth, 'down', 2), 2).toLocaleString()
			: '-';

	return `${arrow_arr[setIndex()]}${follower_growth_rate}(${follower_growth})`;
};

/** 타겟에 맞는 필터데이터 리스트를 찾는 함수  */
const findTargetFilterDataList = (platform: PlatformCode, label_code: string) =>
	filter_data_mapper[platform].find((item) => item.label_code === label_code)?.list;
/** db 필터 값을 view값으로 */
export const codeToName = (platform: PlatformCode, label_code: string, value: string) => {
	const target_list = findTargetFilterDataList(platform, label_code);

	if (!target_list) return;

	if (label_code === 'categories') {
		if (value === 'all') return '전체';
		else return value;
	}

	const result_name = target_list.find((item) => item.code === value)?.name;

	return result_name ?? '';
};
/** view 필터 값을 db값으로 */
export const nameToCode = (platform: PlatformCode, label_code: string, value: string) => {
	const target_list = findTargetFilterDataList(platform, label_code);

	if (!target_list) return;

	if (label_code === 'categories') {
		if (value === '전체') return 'all';
		else return value;
	}

	const result_code = target_list.find((item) => item.name === value)?.code;

	return result_code ?? 'all';
};
